import { h, ComponentChild } from 'preact'
import BetaBadge from '../ui-components/BetaBadge'
import ButtonControl from '../button-control'
import Switcher from '../control/Switcher'
import SimplePanel from '../ui-components/SimplePanel'

type Props = {
  title: string,
  description: string,
  giveFeedbackLink?: string,
  previewImage: ComponentChild,
  isEnabled: boolean,
  onToggleFeature: () => void
}

const ExperimentalFeature = ({ title, description, giveFeedbackLink, previewImage, isEnabled, onToggleFeature }: Props) => (
  <SimplePanel image={previewImage} action={<Switcher on={isEnabled} onChange={onToggleFeature} customClass='panel-switch' />}>
    <div class='experimental-feature__title'><h5>{title}</h5><div><BetaBadge /></div></div>
    <div class='experimental-feature__description'>{description}</div>
    {giveFeedbackLink ?
      <ButtonControl
        title='Give Feedback'
        newStyle
        size='medium'
        onClick={() => window.open(giveFeedbackLink)}
      />
      : null}
  </SimplePanel>
)

export default ExperimentalFeature
